/* 
	该模块是用于定义action对象中type类型的常量值，目的只有一个：便于管理的同时防止程序员单词写错
*/
export const INCREMENT = 'increment'
export const DECREMENT = 'decrement'
export const ADD_PERSON = 'add_person'
export const SET_PLATFORM='set_platform'
export const SET_FOOTER='set_footer'
export const SET_DIALOG='set_dialog'
export const SET_ALIVE='set_alive'